/** Keeps `/dev/*` tooling out of production. */
export default defineNuxtRouteMiddleware(() => {
  const env = useRuntimeConfig().public.environment
  if (env === 'prod') {
    return navigateTo('/')
  }
})
